export enum ESearchInputDisplayMode {
  SMALL = 'small',
  LARGE = 'large',
}
